import React from 'react';

import { Form } from 'libs/forms';
import { Button } from 'components';
import { FormButton } from 'libs/forms/styles';
import PropTypes from 'prop-types';
import { Modal } from 'apps/modals/views/modal';
import styled from 'styled-components';
import { clientStore } from 'apps/client/app';

class QualityForm extends Modal {
  render() {
    const entriesArray = Array.from(this.props.formStore.fieldStores.entries());

    return (
      <QualityFormWrapper>
        {clientStore.currentPortal === 'INTERMEDIATOR' ? (
          <>
            <TwoColumnsHeader>
              <div>
                <h1>
                  Check the client responses to the qualification form here
                </h1>
              </div>
            </TwoColumnsHeader>

            <AnswersGroup>
              {entriesArray.map(entry => {
                const obj = entry[1];
                const question = obj.conf.label;
                const selectedValue = obj.value;
                return (
                  <Answer key={entry[0]}>
                    {' '}
                    <p>
                      <span>{question}: </span> {selectedValue || '/'}
                    </p>
                  </Answer>
                );
              })}
            </AnswersGroup>
          </>
        ) : (
          <>
            {this.props.rfqApp?.quotingPriorityData?.length !==
            undefined ? null : (
              <div>
                <RFQSubmittedHeader>
                  <img src='data:image/png;base64,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'></img>

                  <h2>RFQ Submitted</h2>
                </RFQSubmittedHeader>
                <Divider></Divider>
              </div>
            )}
            <TwoColumnsHeader>
              <div>
                <h1>Boost your chances for a great Match!</h1>
                <p>
                  Submit answers to as many relevant questions to your order for
                  more comprehensive and accurate quotes from our team of
                  experts and our network of quality assured manufacturers.
                  <br></br>
                  <br></br> The questions marked with an (*) are strongly
                  recommended.<br></br>
                  <a href='https://help.wikifactory.com/en/articles/6291370-qualification-form'>
                    Learn more about why this helps us, help you better
                  </a>
                </p>
              </div>
              <RightColumn>
                <SkipButton
                  onMouseDown={() => {
                    this.props.skipAction();
                  }}
                  icon='arrow_right'
                  iconPosition='right'
                  text='Skip for now'
                >
                  Skip for now
                </SkipButton>
              </RightColumn>
            </TwoColumnsHeader>

            <StyledQualityFormContent
              formStore={this.props.formStore}
              formTitle={this.props.formStore.formTitle}
              responsive
              autocomplete='off'
            ></StyledQualityFormContent>

            <SubmitDiv>
              <Button onClick={this.props.buttonHandler} text='Done'></Button>
            </SubmitDiv>
          </>
        )}

        <EmptySpaceBottom></EmptySpaceBottom>
      </QualityFormWrapper>
    );
  }
}

export const TwoColumnsHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  align-self: flex-start;
  padding: 0px 10px 20px 10px;
  color: #000;
  text-align: center;
  padding: 0px 3%;
  margin-bottom: 2em;
`;

export const RightColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RFQSubmittedHeader = styled.div`
  padding: 0px 40px 20px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #000;
`;

export const StyledQualityFormContent = styled(Form)`
  div {
    align-self: self-start;
  }
  box-shadow: none;
  padding: 0px 0px 20px 0px;

  label {
    margin-left: 5px;
  }
`;

export const QualityFormWrapper = styled.div`
  font-family: HelveticaNowDisplay, Helvetica, sans-serif;

  hr {
    height: 1px;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #333;
  border-radius: 100%;
  margin-top: 20px;
`;

export const SkipButton = styled(FormButton)`
  background-color: white;
  border: none;
  color: var(--chakra-colors-blue-900);
  font-weight: bold;
  svg {
    margin-left: 0.5em;
  }
`;

export const SubmitDiv = styled.div`
  background-color: white;
  bottom: 0;
  width: 100%;

  position: sticky;
  text-align: center;
  padding: 10px 20px;
  pointer-events: none;

  button {
    margin: 0 auto;
    margin-bottom: 3em;
    pointer-events: all;
  }
  /* ff 3.6+ */
  background: -moz-linear-gradient(
    180deg,
    rgba(255, 255, 0, 0) 0%,
    rgba(255, 255, 255, 1) 81%
  );

  /* safari 5.1+,chrome 10+ */
  background: -webkit-linear-gradient(
    180deg,
    rgba(255, 255, 0, 0) 0%,
    rgba(255, 255, 255, 1) 81%
  );

  /* opera 11.10+ */
  background: -o-linear-gradient(
    180deg,
    rgba(255, 255, 0, 0) 0%,
    rgba(255, 255, 255, 1) 81%
  );

  /* ie 6-9 */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#FFFFFF', endColorstr='#FFFF00', GradientType=1 );

  /* ie 10+ */
  background: -ms-linear-gradient(
    180deg,
    rgba(255, 255, 0, 0) 0%,
    rgba(255, 255, 255, 1) 81%
  );

  /* global 94%+ browsers support */
  background: linear-gradient(
    180deg,
    rgba(255, 255, 0, 0) 0%,
    rgba(255, 255, 255, 1) 81%
  );
`;

export const EmptySpaceBottom = styled.div`
  height: 0em;
`;

export const AnswersGroup = styled.div``;
QualityForm.propTypes = {
  formStore: PropTypes.object,
};

export const Answer = styled.div`
  margin-bottom: 1em;

  span {
    font-weight: bold;
  }
`;

export default QualityForm;
